<template>
  <div class="footbar_">
    <div class="con_">
      <div class="con_item2">
        <img src="../../assets/imgs/layout/logo.png" alt="" />
        <p>
          <span class="locicon"></span
          >{{
            $t("LOGIN[4]") ||
            "总部地址：北京市朝阳区建国门外大街丙24号，京泰大厦10层"
          }}
        </p>
        <p>
          <span class="phoneicon"></span>{{ $t("LOGIN[5]") || "联系方式：" }}400
          880 8820
        </p>
        <p>
          <span class="emailicon"></span
          >{{ $t("LOGIN[6]") || "邮&nbsp;&nbsp;编：" }}100022
        </p>
        <p>
          <span class="faxicon"></span>{{ $t("LOGIN[7]") || "传真：" }}+8610
          8453 9719
        </p>
        <p>
          <span class="websiteicon"></span
          >{{ $t("LOGIN[8]") || "网址：" }}www.medilink-global.com.cn
        </p>
      </div>
      <div v-if="!isYtEnv" class="con_item2 flex_">
        <div class="con_item3">
          <p class="bold">{{ $t("AMG[0]") || "关于我们" }}</p>
          <a href=""
            ><router-link :to="{ path: '/about', query: { loc: 1 } }">{{
              $t("AMG[4]") || "企业简介"
            }}</router-link></a
          >
          <a href=""
            ><router-link :to="{ path: '/about', query: { loc: 2 } }">{{
              $t("AMG[5]") || "发展历程"
            }}</router-link></a
          >
          <a href=""
            ><router-link :to="{ path: '/about', query: { loc: 3 } }">{{
              $t("AMG[6]") || "核心优势"
            }}</router-link></a
          >
        </div>
        <div class="con_item3">
          <p class="bold">{{ $t("AMG[1]") || "产品家族" }}</p>
          <a href=""
            ><router-link :to="{ path: '/thirdService/healthPlan' }">{{
              $t("AMG[7]") || "企业定制方案"
            }}</router-link></a
          >
          <a href=""
            ><router-link
              :to="{ path: '/products/personal', query: { loc: 4 } }"
              >{{ $t("AMG[8]") || "个人健康管理方案" }}</router-link
            ></a
          >
          <a v-if="!enLang" href="https://yutai365.com/middle/productDetails">{{
            $t("AMG[9]") || "新燕宝"
          }}</a>
          <a v-if="!enLang" href="https://yutai365.com/middle/productDetails2">
            {{ $t("AMG[10]") || "喜燕宝" }}</a
          >
          <!-- <a href="https://yutai365.com/middle/productDetails3">{{
            $t("AMG[11]") || "福燕宝"
          }}</a> -->
          <a v-if="!enLang" href="https://yutai365.com/middle/productDetails5">{{
            $t("AMG[12]") || "小燕宝"
          }}</a>
          <a href="https://yutai365.com/middle/productDetails4">{{
            $t("AMG[13]") || "臻荣耀"
          }}</a>
        </div>
        <div class="con_item3">
          <p class="bold">{{ $t("AMG[2]") || "第三方管理服务" }}</p>
          <a href=""
            ><router-link :to="{ path: '/thirdService/thirdPartService' }">{{
              $t("AMG[14]") || "第三方管理服务"
            }}</router-link></a
          >
          <a href=""
            ><router-link :to="{ path: '/vipService' }">{{
              $t("AMG[15]") || "会员服务"
            }}</router-link></a
          >
          <a href=""
            ><router-link :to="{ path: '/specialService' }">{{
              $t("AMG[16]") || "特色服务"
            }}</router-link></a
          >
        </div>
        <div class="con_item3">
          <p class="bold">{{ $t("AMG[3]") || "医疗服务" }}</p>
          <a href=""
            ><router-link
              :to="{ path: '/medicalService/company', query: { loc: 5 } }"
              >{{ $t("AMG[18]") || "企业健保服务" }}</router-link
            ></a
          >
        </div>
      </div>
      <div v-else class="con_item2 flex_">
        <div class="con_item3">
          <p class="bold">{{ $t("AMG[0]") || "关于我们" }}</p>
          <a href="https://www.medilink-global.com.cn/MediLink/about">{{
            $t("AMG[4]") || "企业简介"
          }}</a>
          <a href="https://www.medilink-global.com.cn/MediLink/about">{{
            $t("AMG[5]") || "发展历程"
          }}</a>
          <a href="https://www.medilink-global.com.cn/MediLink/about">{{
            $t("AMG[6]") || "核心优势"
          }}</a>
        </div>
        <div class="con_item3">
          <p class="bold">{{ $t("AMG[1]") || "产品家族" }}</p>
          <a
            href="https://www.medilink-global.com.cn/MediLink/thirdService/healthPlan"
            >{{ $t("AMG[7]") || "企业定制方案" }}</a
          >
          <a
            href="https://www.medilink-global.com.cn/MediLink/products/personal"
            >{{ $t("AMG[8]") || "个人健康管理方案" }}</a
          >
          <a v-if="!enLang" href=""
            ><router-link
              :to="{ path: '/productDetails', query: { loc: 4 } }"
              >{{ $t("AMG[9]") || "新燕宝" }}</router-link
            ></a
          >
          <a v-if="!enLang" href=""
            ><router-link
              :to="{ path: '/productDetails2', query: { loc: 4 } }"
              >{{ $t("AMG[10]") || "喜燕宝" }}</router-link
            ></a
          >
          <!-- <a href=""
            ><router-link
              :to="{ path: '/productDetails3', query: { loc: 4 } }"
              >{{ $t("AMG[11]") || "福燕宝" }}</router-link
            ></a
          > -->
          <a v-if="!enLang" href=""
            ><router-link
              :to="{ path: '/productDetails5', query: { loc: 4 } }"
              >{{ $t("AMG[12]") || "小燕宝" }}</router-link
            ></a
          >
          <a href=""
            ><router-link
              :to="{ path: '/productDetails4', query: { loc: 4 } }"
              >{{ $t("AMG[13]") || "臻荣耀" }}</router-link
            ></a
          >
        </div>
        <div class="con_item3">
          <p class="bold">{{ $t("AMG[2]") || "第三方管理服务" }}</p>
          <a
            href="https://www.medilink-global.com.cn/MediLink/thirdService/thirdPartService"
            >{{ $t("AMG[14]") || "第三方管理服务" }}</a
          >
          <a href="https://www.medilink-global.com.cn/MediLink/vipService">{{
            $t("AMG[15]") || "会员服务"
          }}</a>
          <a
            href="https://www.medilink-global.com.cn/MediLink/specialService"
            >{{ $t("AMG[16]") || "特色服务" }}</a
          >
        </div>
        <div class="con_item3">
          <p class="bold">{{ $t("AMG[3]") || "医疗服务" }}</p>
          <a
            href="https://www.medilink-global.com.cn/MediLink/medicalService/company"
            >{{ $t("AMG[18]") || "企业健保服务" }}</a
          >
        </div>
      </div>
      <div class="con_item2 flex_">
        <div class="con_item4">
          <img src="../../assets/imgs/layout/saoma.png" alt="" />
          <span>{{ $t("AMG[21]") || "中间带在线" }}</span>
        </div>
        <div class="con_item4">
          <img src="../../assets/imgs/layout/erweima24.jpeg" alt="" />
          <span>{{ $t("AMG[22]") || "中间带24小时" }}</span>
        </div>
        <div
          :class="['con_item4', $i18n.locale === 'en-us' ? 'con_item4_en' : '']"
        >
          <img src="../../assets/imgs/layout/ma3.jpg" alt="" />
          <span>{{ $t("AMG[23]") || "MediLink Global 中间带" }}</span>
        </div>
      </div>
    </div>
    <p v-if="isYtEnv">
      宇泰保险经纪（北京）有限公司©版权所有 ALL RIGHTS RESERVED 京ICP备
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        style="color: white; cursor: pointer"
      >
      16001338号-4
      </a>
    </p>
    <p v-else>
      Copyright © 2008 - 2020 MediLink-Global. ALL RIGHTS RESERVED 京ICP备
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        style="color: white; cursor: pointer"
      >
        08007346号-1
      </a>
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isYtEnv: false,
    };
  },
  computed: {
    enLang() {
      // 如果值为en 展示逻辑变更，不显示中英切换
      const flag = sessionStorage.getItem('lang') === 'en'
      return flag
    }
  },
  mounted() {
    //判断域名，是否是
    const currentHost = window.location.host;
    if (currentHost === "yutai365.com") {
      this.isYtEnv = true;
    }
  },
};
</script>

<style lang="less" scoped>
.footbar_ {
  width: 100vw;
  background: #2c2c31;
  background-size: 100% 100%;
  padding: 58px 0 0 0;
  .con_ {
    display: flex;
    justify-content: space-between;
    align-items: initial;
    font-size: 14px;
    padding: 0 83px;
    color: #fff;
    .con_item2 {
      &.flex_ {
        display: flex;
        justify-content: space-between;
      }
      &:first-child {
        // width:460px;
        width: 29%;
        img {
          width: 119px;
          height: 35px;
          object-fit: cover;
          margin-bottom: 30px;
        }
        p {
          // margin-bottom:20px;
        }
      }
      &:nth-child(2) {
        // width:510px;
        width: 33.4%;
        // margin-left: -151px;
      }
      &:last-child {
        // width:270px;
        width: 30%;
      }
      p {
        display: flex;
        align-items: center;
        justify-content: self-start;
      }
      .locicon {
        width: 15px;
        height: 15px;
        display: inline-block;
        background: url(../../assets/imgs/layout/locicon.png) center center
          no-repeat;
        background-size: 13px 17px;
        margin-right: 13px;
      }
      .phoneicon {
        width: 15px;
        height: 15px;
        display: inline-block;
        background: url(../../assets/imgs/layout/phoneicon.png) center center
          no-repeat;
        background-size: 15px 13px;
        margin-right: 13px;
      }
      .emailicon {
        width: 15px;
        height: 15px;
        display: inline-block;
        background: url(../../assets/imgs/layout/emailicon.png) center center
          no-repeat;
        background-size: 14px 11px;
        margin-right: 13px;
      }
      .faxicon {
        width: 15px;
        height: 15px;
        display: inline-block;
        background: url(../../assets/imgs/layout/faxicon.png) center center
          no-repeat;
        background-size: 14px 14px;
        margin-right: 13px;
      }
      .websiteicon {
        width: 15px;
        height: 15px;
        display: inline-block;
        background: url(../../assets/imgs/layout/websiteicon.png) center center
          no-repeat;
        background-size: 15px 15px;
        margin-right: 13px;
      }
      .con_item3 {
        display: flex;
        flex-direction: column;
        p {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 10px;
        }
        a {
          font-size: 14px;
          color: #fff;
          padding: 5px 0;
          opacity: 0.7;
          &:hover {
            opacity: 1;
          }
        }
      }
      .con_item4_en {
        margin-top: -119px !important;
      }
      .con_item4 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        // margin-right:33px;
        margin-top: -96px;
        width: 143px;
        align-items: center;
        img {
          width: 109px;
          height: 109px;
          object-fit: cover;
          margin-bottom: 5px;
        }
        span {
          text-align: center;
        }
        &:last-child {
          margin-right: 0;
          margin-top: -75px;
          span {
            // white-space:nowrap;
            text-align: center;
          }
        }
      }
    }
  }
  & > p {
    margin-top: 38px;
    text-align: center;
    padding: 12px 0;
    color: #fff;
    font-size: 12px;
    background: #2c2c31;
  }
}
</style>
